// Content for Chi Siamo, Contatti, Le Nostre Sedi (replica of spedyfly.com)

export const chiSiamo = {
  title: "Chi \u00e8 Spedy Fly?",
  image:
    "https://images.pexels.com/photos/4487383/pexels-photo-4487383.jpeg?auto=compress&cs=tinysrgb&w=1200",
  paragraphs: [
    [
      { t: "SpedyFly \u00e8 il corriere espresso che offre un servizio di consegna rapido, sicuro e senza limiti di peso o numero di colli, garantendo alti standard qualitativi. Siamo specializzati nel trattamento delle " },
      { t: "spedizioni di grande peso", b: true },
      { t: " e " },
      { t: "voluminosit\u00e0", b: true },
      { t: ", con particolare attenzione a quelle che superano i 300 kg. Che si tratti di " },
      { t: "parti di ricambio per auto", b: true },
      { t: " o altre spedizioni pesanti, SpedyFly \u00e8 il partner ideale per le tue necessit\u00e0 di consegna. Offriamo soluzioni su misura per ogni esigenza, con l\u2019obiettivo di garantire consegne veloci e puntuali su tutto il territorio nazionale." },
    ],
    [
      { t: "Fondata nel 2018, SpedyFly ha saputo crescere velocemente, diventando un punto di riferimento nel settore delle spedizioni in Italia. Grazie alla continua innovazione e all\u2019attenzione alle esigenze dei nostri clienti, siamo in grado di offrire un servizio di alta qualit\u00e0, supportato da una rete di filiali e centri di smistamento distribuiti capillarmente su tutto il territorio italiano." },
    ],
    [
      { t: "Il nostro obiettivo \u00e8 soddisfare le esigenze dei nostri clienti, offrendo soluzioni flessibili e personalizzate, adatte a privati, piccole aziende ed eCommerce. Grazie alla nostra piattaforma avanzata e al software gestionale " },
      { t: "SpedyFly PRO", b: true },
      { t: ", offriamo anche servizi dedicati alle aziende che necessitano di spedizioni rapide e sicure." },
    ],
  ],
  whyTitle: "Perch\u00e9 scegliere SpedyFly?",
  reasons: [
    { h: "Specializzazione nelle spedizioni di grande peso", t: "Siamo particolarmente esperti nella gestione di spedizioni che superano i 300 kg, come parti di ricambio per auto, accessori industriali, macchinari e attrezzature pesanti. Se hai bisogno di spedire articoli voluminosi e pesanti, SpedyFly \u00e8 il corriere che fa al caso tuo." },
    { h: "Servizio di ritiro a domicilio", t: "Prenota il ritiro del tuo pacco e SpedyFly lo ritirer\u00e0 direttamente a casa tua il giorno successivo, se confermi la spedizione entro le ore 23 del giorno precedente." },
    { h: "Consegne rapide e sicure", t: "SpedyFly \u00e8 sinonimo di puntualit\u00e0 e affidabilit\u00e0, con un servizio che garantisce la consegna dei tuoi pacchi in tempo." },
    { h: "Soluzioni per aziende e eCommerce", t: "Grazie al nostro software gestionale SpedyFly PRO, le aziende possono gestire facilmente le spedizioni, ottimizzando la logistica e migliorando l\u2019efficienza delle operazioni." },
    { h: "Assistenza clienti dedicata", t: "Il nostro team di assistenza \u00e8 sempre disponibile per rispondere alle tue domande e supportarti, esclusivamente via e-mail all\u2019indirizzo clienti@spedyfly.com." },
  ],
  closing:
    "Con SpedyFly, ogni spedizione \u00e8 semplice, veloce e sicura, anche quelle pi\u00f9 pesanti e complesse. Scopri il nostro servizio e inizia a spedire oggi stesso!",
};

export const contatti = {
  image:
    "https://images.unsplash.com/photo-1560264280-88b68371db39?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  title: "Il nostro servizio clienti di SpedyFly",
  intro:
    "SpedyFly \u00e8 sempre a tua disposizione per rispondere a tutte le tue domande e supportarti durante il processo di spedizione. Siamo impegnati a garantire un\u2019esperienza utente fluida e senza intoppi, offrendo assistenza rapida e professionale.",
  subTitle: "Cosa possiamo fare per te:",
  items: [
    { h: "Assistenza generale", t: "Risolviamo tutte le tue domande riguardo alle spedizioni, il tracciamento dei pacchi e le opzioni di pagamento." },
    { h: "Supporto tecnico", t: "Se hai bisogno di aiuto con il nostro sito web o con il nostro software gestionale SpedyFly PRO, il nostro team tecnico \u00e8 a tua disposizione." },
    { h: "Gestione spedizioni", t: "Ti assistiamo nel processo di creazione e gestione delle tue spedizioni, dalla prenotazione del ritiro alla consegna." },
    { h: "Problemi con le spedizioni", t: "Se hai riscontrato un problema con una spedizione (ritardi, pacco smarrito, danni), siamo qui per trovare una soluzione." },
    { h: "Come contattarci", t: "Tramite email all\u2019indirizzo spledyfly@gmail.com o compilando il form di contatto in fondo alla pagina." },
  ],
  email: "spledyfly@gmail.com",
};

export const sedi = {
  title: "I Nostri Provider e Sedi",
  intro:
    "SpedyFly si avvale di una rete consolidata di partner e provider logistici per garantire un servizio di spedizione efficiente, sicuro e tempestivo. Collaboriamo con le principali aziende di logistica e corrieri nazionali e internazionali, per offrirti soluzioni di spedizione che rispondano a ogni tipo di esigenza.",
  providersTitle: "I nostri provider",
  providersIntro:
    "Per garantire la qualit\u00e0 e l\u2019affidabilit\u00e0 delle nostre spedizioni, ci avvaliamo di diversi operatori del settore della logistica, tra cui i principali corrieri nazionali e internazionali, che ci supportano nella gestione delle tue spedizioni sia per pacchi leggeri che per merci di grandi dimensioni e pesi superiori a 300 kg. I nostri partner includono alcuni dei leader nel settore, come:",
  providers: [
    "Kuehne + Nagel",
    "DB Schenker",
    "Geodis",
    "XPO Logistics",
    "Nexive",
    "Artoni Group",
    "SDV Logistics",
    "Mainfreight",
    "Sogedi",
    "Ceva Logistics",
  ],
  officesTitle: "Le nostre sedi",
  officesIntro:
    "SpedyFly ha una rete di filiali distribuite capillarmente su tutto il territorio nazionale per garantire che ogni spedizione venga gestita in modo rapido ed efficiente. Le nostre principali sedi sono:",
  regions: [
    {
      name: "Nord Italia",
      offices: [
        { p: "Kuehne + Nagel", a: "Via Filippo Corridoni 1, 20098 San Giuliano Milanese (MI)" },
        { p: "Kuehne + Nagel", a: "Via Torino 11, 10020 Rivarolo Canavese (TO)" },
        { p: "Kuehne + Nagel", a: "Via dell\u2019Industria 10, 40050 Argelato (BO)" },
        { p: "Kuehne + Nagel", a: "Via dei Lavoratori 12, 37057 San Giovanni Lupatoto (VR)" },
        { p: "Kuehne + Nagel", a: "Via Milano 20, 16126 Genova (GE)" },
        { p: "DB Schenker", a: "Via S. Martino 15, 20158 Milano (MI)" },
        { p: "DB Schenker", a: "Strada del Drosso 41, 10135 Torino (TO)" },
        { p: "DB Schenker", a: "Via Emilia Ovest 35, 40128 Bologna (BO)" },
        { p: "DB Schenker", a: "Via dei Lavoratori 16, 37057 San Giovanni Lupatoto (VR)" },
        { p: "DB Schenker", a: "Via Bobbio 43, 16163 Genova (GE)" },
        { p: "Geodis", a: "Via N. Sauro 10, 20090 Cernusco sul Naviglio (MI)" },
        { p: "Geodis", a: "Via Torino 30, 10040 Leini (TO)" },
        { p: "Geodis", a: "Via Emilia Ovest 25, 40128 Bologna (BO)" },
        { p: "Geodis", a: "Via del Lavoro 13, 37057 San Giovanni Lupatoto (VR)" },
        { p: "Geodis", a: "Via Milano 16, 16126 Genova (GE)" },
        { p: "XPO Logistics", a: "Via N. Sauro 10, 20090 Cernusco sul Naviglio (MI)" },
        { p: "XPO Logistics", a: "Via Torino 88, 10132 Torino (TO)" },
        { p: "XPO Logistics", a: "Via Emilia Ovest 29, 40128 Bologna (BO)" },
        { p: "XPO Logistics", a: "Via dei Lavoratori 20, 37057 San Giovanni Lupatoto (VR)" },
        { p: "XPO Logistics", a: "Via Orefici 7, 16123 Genova (GE)" },
        { p: "Nexive", a: "Via G. Mazzini 19, 20090 Cernusco sul Naviglio (MI)" },
        { p: "Nexive", a: "Via Torino 18, 10040 Leini (TO)" },
        { p: "Nexive", a: "Via Emilia Ovest 12, 40128 Bologna (BO)" },
        { p: "Nexive", a: "Via del Lavoro 15, 37057 San Giovanni Lupatoto (VR)" },
        { p: "Nexive", a: "Via Milano 23, 16126 Genova (GE)" },
        { p: "Artoni Group", a: "Via G. Mazzini 12, 20090 Cernusco sul Naviglio (MI)" },
        { p: "Artoni Group", a: "Via Torino 40, 10040 Leini (TO)" },
        { p: "Artoni Group", a: "Via Emilia Ovest 19, 40128 Bologna (BO)" },
        { p: "Artoni Group", a: "Via dei Lavoratori 14, 37057 San Giovanni Lupatoto (VR)" },
        { p: "SDV Logistics", a: "Via L. Da Vinci 9, 20090 Milano (MI)" },
        { p: "SDV Logistics", a: "Strada della Colletta 15, 10156 Torino (TO)" },
        { p: "SDV Logistics", a: "Via Emilia Ovest 12, 40128 Bologna (BO)" },
        { p: "SDV Logistics", a: "Via dei Lavoratori 15, 37057 San Giovanni Lupatoto (VR)" },
        { p: "Mainfreight", a: "Via G. Mazzini 25, 20090 Cernusco sul Naviglio (MI)" },
        { p: "Mainfreight", a: "Via Torino 17, 10040 Leini (TO)" },
        { p: "Mainfreight", a: "Via Emilia Ovest 28, 40128 Bologna (BO)" },
        { p: "Mainfreight", a: "Via dei Lavoratori 10, 37057 San Giovanni Lupatoto (VR)" },
        { p: "Mainfreight", a: "Via Milano 22, 16126 Genova (GE)" },
        { p: "Sogedi", a: "Via G. Mazzini 21, 20090 Cernusco sul Naviglio (MI)" },
        { p: "Sogedi", a: "Via Torino 35, 10040 Leini (TO)" },
        { p: "Sogedi", a: "Via Emilia Ovest 20, 40128 Bologna (BO)" },
        { p: "Ceva Logistics", a: "Via G. Mazzini 20, 20090 Milano (MI)" },
        { p: "Ceva Logistics", a: "Via Torino 18, 10040 Leini (TO)" },
        { p: "Ceva Logistics", a: "Via Emilia Ovest 18, 40128 Bologna (BO)" },
        { p: "Ceva Logistics", a: "Via dei Lavoratori 14, 37057 San Giovanni Lupatoto (VR)" },
      ],
    },
    {
      name: "Centro Italia",
      offices: [
        { p: "Kuehne + Nagel", a: "Via L. Da Vinci 22, 50019 Sesto Fiorentino (FI)" },
        { p: "DB Schenker", a: "Via L. Da Vinci 22, 50019 Sesto Fiorentino (FI)" },
        { p: "Geodis", a: "Via F.lli Cervi 40, 50010 Campi Bisenzio (FI)" },
        { p: "Mainfreight", a: "Via L. Da Vinci 22, 50019 Sesto Fiorentino (FI)" },
        { p: "Kuehne + Nagel", a: "Via delle Galere 15, 57100 Livorno (LI)" },
        { p: "DB Schenker", a: "Via S. Giovanni 50, 57123 Livorno (LI)" },
        { p: "Geodis", a: "Via delle Galere 25, 57100 Livorno (LI)" },
        { p: "XPO Logistics", a: "Via delle Galere 25, 57100 Livorno (LI)" },
      ],
    },
    {
      name: "Sud Italia",
      offices: [
        { p: "Kuehne + Nagel", a: "Via G. Mazzini 18, 80121 Napoli (NA)" },
        { p: "DB Schenker", a: "Via Settetermini 81, 80147 Napoli (NA)" },
        { p: "XPO Logistics", a: "Via F.lli Bandiera 45, 80121 Napoli (NA)" },
        { p: "Geodis", a: "Via G. Mazzini 6, 80121 Napoli (NA)" },
        { p: "Nexive", a: "Via F.lli Bandiera 25, 80147 Napoli (NA)" },
        { p: "Artoni Group", a: "Via F.lli Bandiera 25, 80147 Napoli (NA)" },
      ],
    },
  ],
  closing:
    "Ogni nostra sede \u00e8 dotata di impianti all\u2019avanguardia e personale altamente qualificato, pronto a gestire le tue spedizioni in modo ottimale. Con SpedyFly, hai la garanzia di un servizio di qualit\u00e0, rapido e flessibile, per tutte le tue esigenze logistiche.",
};
